<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {Datetime} from "vue-datetime";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from "moment";

import {getGeography} from "@/api/demographics";
import kpiList from "@/data/kpiDropdown.json";
import kpiListV2 from "@/data/kpiDropdownV2.json";
import sectorDropdown from "@/data/sectorDropdown.json";
import DropDown from "@/view/components/helper/multidropdown/DropDown.vue"
import { getData} from "@/utils";
// import {getAccountSettings} from "@/api/accounts";
import swal from "sweetalert";

export default {
  components: {},
  name: "spending-pulse",
  components: {
    Datetime,
    Treeselect,
    DropDown,
    kpiList
  },
  data() {
    return {
      loadedMap: false,
      active_tab: 0,
      form: {
        seclectedSector: {
          id: "9",
          label: "Restaurants"
        },
        selectedChannel: 1,
        selectedInterval: 'weekly',
        kpiModel: {id: "3",label: "YoY Change"},
        geoModel: {id: "100000",label: "USA"},
        date:{
          start:  moment('2022-08-28').format("YYYY-MM-DD"),
          end:  moment().format("YYYY-MM-DD")
        },
      },
      sectorList: [{
        "id": "9",
        "label": "Restaurants"}
      ],
      subscribed: false,
      channelList:[
        { text: "Total", value: 1},
        { text: "Online", value: 2, disabled: true},
        { text: "In Store", value: 3, disabled: true},
      ],
      intervalList:[
        { text: "Daily", value: 'daily', disabled: true},
        { text: "Weekly", value: 'weekly' },
        { text: "Monthly", value: 'monthly', disabled: true},
      ],
      minDate: moment().subtract(3, "years").startOf("month").format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),
      plotlyValue:'',
      geoOptions: [ ],
      kpiOptions: kpiList,
      kpiOptionsCopy: kpiList,
      geoIsEmpty: true,
      selectionBtn: 5,
      countrySelected: 1,
      radioGroup: 0,
      intervalSets: [],
      oldMapUrl: '',
      companyName: ''
    };
  },
  async beforeMount() {
    document.title = 'Aben Overview'
    this.$store.dispatch(SET_BREADCRUMB, [{title: "Aben Overview"}]);
  },
  
  async mounted() {
    var accountSetting = await this.$store.getters["getAccountSettings"];
    if (!accountSetting.length){
      await this.$store.dispatch("getAccountSettings");
      accountSetting = await this.$store.getters["getAccountSettings"];
    }
    let isSubscribed = accountSetting['company_details']['company']['is_subscribed']
    this.subscribed = !isSubscribed
    this.companyName = accountSetting.company_name
    this.ifEuroGarrage()
    let geoList = await getGeography(isSubscribed)
    this.geoOptions = geoList
    let sectorCollection = sectorDropdown
    
    this.setMaxdate()
    if(!isSubscribed){
      let hubsSpotScript = document.createElement('script')
      hubsSpotScript.setAttribute('src', '//js.hs-scripts.com/21320815.js')
      hubsSpotScript.setAttribute('type', 'text/javascript')
      hubsSpotScript.setAttribute('id', 'hs-script-loader')
      document.body.appendChild(hubsSpotScript)
    }else{
      let joeneCollection = await getData(`/benchmark/aben-overview-sector-list/?company=${accountSetting.company_name}`);
      sectorCollection = sectorDropdown
    
      sectorCollection.forEach((scVal, scKey) => {
        joeneCollection.forEach((jcVal, key) => {
          if(jcVal.obj_id == scVal.id){
            sectorCollection[scKey]['disabled'] = !jcVal.is_active
          }
        })

        try {
          if('children' in scVal){
            scVal['children'].forEach((chVal, chKey) => {
              joeneCollection.forEach((jcVal, key) => {
                if(jcVal.obj_id == chVal.id){
                  sectorCollection[scKey]['children'][chKey]['disabled'] = !jcVal.is_active
                }
              })

              if('children' in chVal){
                chVal['children'].forEach((chhVal, chhKey) => {
                  joeneCollection.forEach((jcVal, key) => {
                    if(jcVal.obj_id == chhVal.id){
                      sectorCollection[scKey]['children'][chKey]['children'][chhKey]['disabled'] = !jcVal.is_active
                    }
                  })

                })
              }
            })
          }
          
        } catch (error) {
          console.log('--spending pulse error :',error)
        }
      });
    }
    
    this.sectorList = sectorCollection
  },
  computed: {
    intervals(){
      let intervals = []
      let currentDateMoment = moment(this.form.date.start)
      let endDateMoment = moment(this.form.date.end)
      let i = 0
      this.radioGroup = 0
      if (this.form.selectedInterval == 'weekly'){
        while (currentDateMoment.day() != 0) {
          currentDateMoment = currentDateMoment.subtract(1, 'days')
        }
        let valueDate = {
          index: i,
          start: currentDateMoment.format('MM/DD/YYYY'),
          end: currentDateMoment.add(6, 'days').format('MM/DD/YYYY'),
          incomplete: true
        }
        i= i+1
        intervals.push(valueDate)
        currentDateMoment = moment(valueDate.start).add(7, 'days')
        while (currentDateMoment.unix() <= endDateMoment.unix()  ) {
          if ( currentDateMoment.day() == 0 ){
            let valueDate = {
              index: i,
              start: currentDateMoment.format('MM/DD/YYYY'),
              end: currentDateMoment.add(6, 'days').format('MM/DD/YYYY'),
              incomplete: false
            }
            intervals.push(valueDate)
            currentDateMoment = moment(valueDate.start).add(7, 'days')
            i= i+1
          }
        }
      }else if(this.form.selectedInterval == 'daily'){
        while (currentDateMoment.unix() <= endDateMoment.unix()  ) {
          let valueDate = {
            index: i,
            start: currentDateMoment.format('MM/DD/YYYY'),
            end: '',
            incomplete: false
          }
          intervals.push(valueDate)
          currentDateMoment = moment(valueDate.start).add(1, 'days')
          i= i+1
        }
      }
      return intervals
    },
    calculatePlotlyUrl(){

      let currentDateMoment = moment(this.form.date.start)
      let endDateMoment = moment(this.form.date.end)
      if( currentDateMoment > endDateMoment){
        swal("Notice", "Date 'To' dropdown should not be before of Date 'From'. " );
        return false
      }
      this.loadedMap = false
      let formValue = this.form
      let sectorId = formValue.seclectedSector
      let dateValue = ''
      let kpi_id = formValue.kpiModel
      let geo_id = formValue.geoModel
      let channel_id = formValue.selectedChannel
      let interval = formValue.selectedInterval
      let geo_level = this.selectionBtn
      let geoArgs = ''
      if (geo_id != null){
        geo_id = geo_id.id
        this.geoIsEmpty= false
      }
      if (kpi_id != null){
        kpi_id = kpi_id.id
      }
      if (sectorId  != null){
        sectorId = sectorId.id
      }
      let ifCounty = this.geoOptions.filter(geo => geo.id == geo_id)
      this.countrySelected = ifCounty.length
      if (this.countrySelected == 1){
        geoArgs = `&geo_level=${geo_level}`
      }
      if (this.intervalSets.length > 0){
        dateValue = moment(this.intervalSets[this.radioGroup].start).format('YYYY-MM-DD')
      }
      let iframeUrl = `${process.env.VUE_APP_API_URL}/benchmark/aben-overview-generate-maps/?sector_id=${sectorId}&date=${dateValue}&kpi_id=${kpi_id}&geo_id=${geo_id}&channel_id=${channel_id}${geoArgs}&interval=${interval}`
      if (iframeUrl == this.oldMapUrl){
        this.onLoadIframe(true)
      }
      this.oldMapUrl = iframeUrl

      return iframeUrl
    }
  },
  watch: {
    intervals(data){
      this.intervalSets = data.reverse()
    },
    "form.selectedInterval"(){
      let kpiCollection = this.kpiOptions
      let selectedInterval = this.form.selectedInterval
      if (selectedInterval == 'daily'){
        try {
          this.kpiOptions = kpiCollection.map(o => ({ // this is manualy disable all children for joene
            ...o,
            children: 'children' in o ? o.children.map(p => ({ 
              ...p,
              disabled: false
            })) : []
          }));
        } catch (error) {
          console.log(error)
        }
      }else{
        this.kpiOptions = this.kpiOptionsCopy
      }
    }
  },
  methods: {
    async setMaxdate(){
      try {
        let latestDate = await getData(`/benchmark/aben-overview-latest-date/`)
        let currentDateMoment = moment(latestDate['date'])
        while (currentDateMoment.day() != 6) {
          currentDateMoment = currentDateMoment.add(1, 'days')
        }
        this.form.date.end = currentDateMoment.format('YYYY-MM-DD')
        this.maxDate = currentDateMoment.format('YYYY-MM-DD')
      } catch (error) {
        console.log('error in setMaxDate', error)
      }
    },
    ifEuroGarrage(){
      console.log('Company Name: ', this.companyName)
      if (this.companyName == 'Euro Garages'){
        this.intervalList = [
          { text: "Daily", value: 'daily'},
          { text: "Weekly", value: 'weekly' },
          { text: "Monthly", value: 'monthly', disabled: true},
        ]
        this.kpiOptions = kpiListV2
        this.kpiOptionsCopy = kpiListV2
        this.form.seclectedSector = {
          id: "25",
          label: "Fuel & Convenience"
        }
      }else if(!this.subscribed){
        this.kpiOptions = kpiListV2
        this.kpiOptionsCopy = kpiListV2
      }
    },
    onLoadIframe(res){
      this.loadedMap = true
    },
    handleSelectionGeo(selected){
      this.form.geoModel = selected
    },
    handleSelectionSector(selected){
      this.form.seclectedSector = selected
    },
    handleSelectionkpi(selected){
      this.form.kpiModel = selected
    }
  }
};
</script>

<template>
  <v-app class="bg-transparent">
    <div  class="content-box aben-overview-c" >
      <v-tabs
        v-model="active_tab"
        background-color="white"
        color="deep-purple accent-4"
        left
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab1">Maps</v-tab>
        <v-tab href="#tab2" disabled>Plots</v-tab>
      </v-tabs>
      <v-tabs-items v-model="active_tab">
        <v-tab-item :value="'tab1'">
          <div class= "d-flex zindex-99 pa-5 pb-0 tab1-menu">
            <div class="mr-2 sector-c">
              <div class="sublabel">Sector</div>
              <div>
                <drop-down 
                  :options="sectorList" 
                  name="test" 
                  v-model="form.seclectedSector" 
                  :handleSelection="handleSelectionSector"
                  :preselect="form.seclectedSector" 
                  >
                </drop-down>
              </div>
            </div>
            <div class="mr-2 dateselect-c" >
              <div class="sublabel">From</div>
              <datetime
                input-class="form-control"
                format="yyyy-MM-dd"
                v-model="form.date.start"
                value-zone="local"
                zone="local"
                :max-datetime="maxDate"
                :min-datetime="minDate"
            ></datetime>
            </div>
            <div class="mr-2 dateselect-c" >
              <div class="sublabel">To</div>
              <datetime
                  input-class="form-control"
                  format="yyyy-MM-dd"
                  v-model="form.date.end"
                  value-zone="local"
                  zone="local"
                  :max-datetime="maxDate"
                  :min-datetime="minDate"
              ></datetime>
            </div>
            <div class="mr-2 kpi-c" >
              <div class="sublabel">KPI</div>
                <drop-down 
                  :options="kpiOptions" 
                  :preselect="form.kpiModel"
                  name="kpiSector" 
                  v-model="form.kpiMode" 
                  :handleSelection="handleSelectionkpi">
                </drop-down>
            </div>
            <div class="mr-2 geo-c" >
              <div class="sublabel">Geography</div>
              <div>
                <drop-down 
                  :options="geoOptions" 
                  :preselect="form.geoModel"
                  name="test" 
                  v-model="form.geoModel" 
                  :handleSelection="handleSelectionGeo">
                </drop-down>
              </div>
              <span v-if="geoIsEmpty" class="red--text">Required</span>
            </div>
            <div class="mr-2 channel-c">
              <div class="sublabel">Sales Channel</div>
              <v-select
                class="h42 f13"
                v-model="form.selectedChannel"
                :items="channelList"
                placeholder="Select Channel"
                required
                dense
                outlined
                background-color="#ffffff"
                :menu-props="{ top: false, offsetY: true }"
              ></v-select>
            </div>
            <div class="mr-2 interval-c" >
              <div class="sublabel">Interval</div>
              <v-select
                class="h42 f13"
                v-model="form.selectedInterval"
                :items="intervalList"
                placeholder="Select Interval"
                required
                dense
                outlined
                background-color="#ffffff"
                :menu-props="{ top: false, offsetY: true }"
              ></v-select>
            </div>
          </div>
          <div class="tab1-main-content">
            <div 
              v-if="countrySelected == 1"
              class="select-btn-con"
            >
              <v-btn-toggle
              v-model="selectionBtn"
              >
                <v-btn :value="5">
                  <span>State</span>
                </v-btn>
                <v-btn :value="3">
                  <span>DMA®</span>
                </v-btn>
                <v-btn :value="2" :disabled="subscribed">
                  <span>County</span>
                </v-btn>
              </v-btn-toggle>
            </div>
            
            <div
              v-if="!loadedMap"
              class="text-center loading-div">
              <p>Fetching Data ...</p>
              <v-progress-circular
                indeterminate
                size="30"
              ></v-progress-circular>
            </div>
            <div>
              <v-radio-group class="radio-list" v-model="radioGroup">
                <div class="swi-con">
                  Select {{form.selectedInterval}} interval
                  <div class="radio-con">
                    <v-radio
                      v-for="(item, index) in intervalSets"
                      :key="index"
                      :label=" form.selectedInterval == 'weekly' ? `${item.start} - ${item.end}` : `${item.start}`"
                      :value="index"
                    ></v-radio>
                  </div>
                </div>
              </v-radio-group>
            </div>
            <iframe
              id="mapgeo"
              :src="calculatePlotlyUrl"
              @load="onLoadIframe"
              title="Aben Overview Map"
              style="overflow:hidden;height:100%;width:100%;border: none;">
            </iframe>
          </div>
        </v-tab-item>
      </v-tabs-items>
  </div>
  </v-app>
</template>



<style >
.swi-con{
  font-size: 13px;
  padding-left: 5px;
  font-weight: 700;
  text-transform: capitalize;
}
.radio-list .radio-con{
  height: 170px;
  overflow: auto;
}
.aben-overview-c .zindex-99{
  position: relative;
  z-index: 10;
}
.aben-overview-c .h42{
  height: 42px;
}
.sublabel{
  font-size: 0.875rem;
}
.aben-overview-c input.vdatetime-input.form-control{
  min-height: 40px; /* date field */
}
.aben-overview-c input.vue-treeselect__input{
  height: 38px !important;
}

.aben-overview-c .vue-treeselect__control {
    border: 2px solid #9e9e9e Im !important;
}
.aben-overview-c .vdatetime-input.form-control{
    border: 1px solid #9e9e9e
}
.aben-overview-c div.f13{
  font-size: 13px;
}
.aben-overview-c .tab1-main-content{
  height: 500px; 
  margin-top: 105px;
  z-index: 1;
}
.aben-overview-c .tab1-menu{
  position: absolute;
  z-index: 2;
}
.aben-overview-c  .loading-div{
  padding-top: 100px;
  position: absolute;
  width: 100%;
  background-color: #c3c8e98f;
  height: 100%;
}
.aben-overview-c .select-btn-con{
  text-align: center;
}
.aben-overview-c .select-btn-con button.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default,
.aben-overview-c .select-btn-con button.v-btn.v-btn--disabled.v-btn--has-bg.theme--light.v-size--default{
  text-transform: initial;
  background-color: transparent !important;
  border: 1px solid #1986d5 !important;
  height: 32px !important;
  width: 70px;
}
.aben-overview-c .select-btn-con button.v-btn.v-btn--disabled.v-btn--has-bg.theme--light.v-size--default{
  border: 1px solid gray !important;
  }

.aben-overview-c .select-btn-con button.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default{
  background-color: #1986d5 !important;
  color: white !important;
  opacity: 1 !important;
}
.aben-overview-c .select-btn-con button.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before span{
  color: white !important;
}

.aben-overview-c .sector-c{
  width: 220px;
}


.aben-overview-c .channel-c,
.aben-overview-c .interval-c{
  width: 150px;
}

.aben-overview-c .dateselect-c{
  width: 100px;
}
.aben-overview-c .kpi-c,
.aben-overview-c .geo-c{
  width: 200px;
}
.radio-list{
  position: absolute;
  background-color:rgba(255,255,255,.68);
  padding: 10px;
  margin-top: 0px;
  margin-left: 10px;
  top: 150px;
}
.radio-list label{
  margin-bottom: 0px;
  font-size: 12px;
}

.radio-list .v-icon.v-icon{
  font-size: 18px;
}
@media only screen and (max-width: 1300px) {
  .aben-overview-c .tab1-menu{
    position: relative;
    height: 80px;
  }
  .aben-overview-c .tab1-main-content {
    margin-top: 30px;
  }
}
</style>
